import { render, staticRenderFns } from "./TreatyNoHelpList.vue?vue&type=template&id=87bf2e56&"
import script from "./TreatyNoHelpList.vue?vue&type=script&lang=js&"
export * from "./TreatyNoHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports